export { extract } from '../RicosContentAPI/extract.js';
